"use client";

import { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useRouter, useSearchParams } from "next/navigation";
import Image from "next/image";
import Cookies from "js-cookie";
import { APPLICATION_ID, MSA_TOKEN } from "@/constants";
import LogoContainer2 from "@/component/Shared/LogoContainer2";
import NextLink from "next/link";
import Link from "@mui/material/Link";
const Auth = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const IS_REDIRECTED = searchParams.get("isRedirected");

  // auto login if token exists
  useEffect(() => {
    const token = Cookies.get(MSA_TOKEN);
    const applicationId = localStorage.getItem(APPLICATION_ID);
    if (token) {
      // router.push(`/dashboard?applicationId=${applicationId}`);
      router.push(
        `/dashboard?applicationId=${applicationId}${
          IS_REDIRECTED ? "&isRedirected=yes" : ""
        }`,
      );
    }
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100dvh",
        overflow: "hidden",
        backgroundImage: "url('/assets/images/MSABackground.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Navbar */}
      <Box
        component="nav"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          height: { xs: 64, sm: 72, md: 80 },
          px: { xs: 2, sm: 3, md: 6 },
          backgroundColor: "rgba(10,10,10,0.85)",
          backdropFilter: "blur(6px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            width: { xs: 95, sm: 110, md: 130 },
            display: "flex",
            alignItems: "center",
          }}
        >
          <Image
            src="/assets/images/MSAWHITELOGO.svg"
            alt="MSA Logo"
            width={130}
            height={40}
            style={{
              width: "100%",
              height: "auto",
              objectFit: "contain",
            }}
          />
        </Box>

      </Box>
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.4)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: 3,
          textAlign: "center",
        }}
      >
        {/* Logo */}
        {/* <Box sx={{ mb: 4, width: "200px" }}>
          <Image
            src="/assets/images/MSAWHITELOGO.svg"
            alt="MSA Logo"
            width={200}
            height={80}
            style={{ width: "100%", height: "auto", objectFit: "contain" }}
          />
        </Box> */}
        <LogoContainer2 />

        {/* Heading */}
        <Typography
          variant="h4"
          sx={{
            fontFamily: "SF Pro",
            fontWeight: 400, // make default regular
            color: "#fff",
            mb: 2,
          }}
        >
          Your{" "}
          <span
            style={{
              textDecoration: "line-through",
              textDecorationColor: "#FF0000",
              textDecorationThickness: "2px",
            }}
          >
            Uber
          </span>{" "}
          <strong>
            Private <br /> Driver
          </strong>{" "}
          App
        </Typography>

        {/* Subheading */}
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 400,
            color: "#E0E0E0",
            mb: 4,
          }}
        >
          {/* Welcome to Exclusive, Easy and Enjoyable rides Anytime, Anywhere and
          Anyplace. */}
          Provide Exclusive, Easy and Enjoyable rides <br /> Anytime, Anywhere
          and Anyplace
        </Typography>

        {/* Buttons */}
        <Button
          onClick={() => router.push("/signup")}
          sx={{
            backgroundColor: "#5A5A5A", // medium grey
            color: "#FFFFFF",
            borderRadius: "100px",
            height: 44,
            fontSize: 16,
            fontWeight: 500,
            textTransform: "none",
            mb: 2,
            "&:hover": {
              backgroundColor: "#4A4A4A", // darker grey on hover
            },
          }}
          fullWidth
          variant="contained"
        >
          New Driver
        </Button>

        <Button
          onClick={() => router.push("/login")}
          sx={{
            borderColor: "#FFFFFF",
            color: "#FFFFFF",
            borderRadius: "100px",
            height: 44,
            fontSize: 16,
            fontWeight: 500,
            textTransform: "none",
            display: "flex",
            gap: 1,
            alignItems: "center",
          }}
          fullWidth
          variant="outlined"
        >
          Returning Driver
        </Button>

        {/* Disclaimer */}
        <Typography
          sx={{
            mt: 4,
            color: "#aaa",
            fontSize: 11,
            lineHeight: 1.4,
          }}
        >
          * Credit Card processing fees including Apple Pay and Google Pay are
          charged by Payment Processors (Stripe, PayPal, etc.) not by
          MyServiceApp Inc.
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            ml: 1,
            alignItems: "center",
          }}
        >
          <NextLink href="/terms-and-conditions" passHref legacyBehavior>
            <Link underline="hover" fontSize={11} color="#99CCFF">
              Term and Conditions
            </Link>
          </NextLink>

          <NextLink href="/privacy-and-policy" passHref legacyBehavior>
            <Link underline="hover" fontSize={11} color="#99CCFF  ">
              Privacy Policy
            </Link>
          </NextLink>
        </Box>
      </Box>
    </Box>
  );
};

export default Auth;
